import React, { useEffect, useState } from "react";
import { Table, Offcanvas } from "react-bootstrap";
import Moment from "react-moment";
import SplitPane from "react-split-pane";
import { useParams } from "react-router";
import { studySubjectManagementServices } from "../../../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";

const ViewSubjectHistory = ({ tableRef, onMouseDown, Show, Hide, Title, subjectId, siteId }) => {
  const [history, setHistory] = useState([]);
  const [columnLabel, setColumnLabel] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  const [siteHistory, setSiteHistory] = useState([]);
  const [historyLoader, setHistoryLoader] = useState(false);  
  let { studyId } = useParams();

  const getStudySubjectAutitTrials = async (e) => {
    setHistoryLoader(true);
    let data = await studySubjectManagementServices.getStudySubjectAuditTrials(
      studyId,
      subjectId, siteId
    );
    setSiteHistory(data?.data || []);
    setHistoryLoader(false);
  };

  useEffect(() => {
    setColumnLabel("");
    setHistory([]);
    if(subjectId && siteId){
        getStudySubjectAutitTrials();
    }
  }, [subjectId, siteId]);

  useEffect(() => {
    setTimeout(() => {
      setShowLoader(false);
    }, 500);
  }, [columnLabel]);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{width: 900}}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <SplitPane
            split="vertical"
            minSize={"30%"}
            style={{ height: "-webkit-fill-available" }}
          >
            {historyLoader ? (
              <PageLoader/>
            ) : (
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      className="text-center"
                      style={{ width: 45 }}
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Columns</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>
                      Latest Version
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {siteHistory?.map((item, index) => (
                    <tr
                      className={`CP ${
                        item?.columnLabel === columnLabel ? "highlighted" : ""
                      }`}
                      onClick={() => {
                        setHistory(item?.history || []);
                        setColumnLabel(item?.columnLabel);
                        setShowLoader(true);
                      }}
                      key={index}
                    >
                      <td className="text-center">{index + 1}</td>
                      <td>{item?.columnLabel}</td>
                      <td>{item?.version}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
            {showLoader ? (
             <PageLoader/>
            ) : history?.length > 0 ? (
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th onMouseDown={(e) => onMouseDown(e, 0)}>Version</th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>
                      Current Value
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>User Id</th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Date | Time</th>
                  </tr>
                </thead>
                <tbody>
                  {history?.reverse()?.map((element, index) => (
                    <tr key={index}>
                      <td>{element?.version}</td>
                      <td>{element?.currentValue}</td>
                      <td>{element?.createdBy}</td>
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {element.createdAt}
                        </Moment>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="hstack justify-content-center h-100">
                <div> Please Select Any Column... </div>
              </div>
            )}
          </SplitPane>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ViewSubjectHistory;
